module.exports = __webpack_public_path__ + "ed754c8f.png";